import { Component, ViewEncapsulation } from '@angular/core';
import module from 'app/modules/cdft/cdft.module';
import { CDFTService } from '../../services/cdft.service';
import { groupErrors } from 'app/core/shared/helper/cdft-error.helper';

interface ErrorList {
  [key: string]: string | string[] | {}[] ;
}

@Component({
  selector: 'app-cdft-error-details',
  standalone: true,
  imports: module,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './cdft-error-details.component.html',
  styleUrl: './cdft-error-details.component.scss'
})

export class CdftErrorDetailsComponent {
  errorList: ErrorList = {};
  valveLabels = [
    'Production Wing Valve',
    'Crown Valve',
    'Surface Safety Valve',
    'Lowen Master Valve',
    'King Wing Valve',
    'A annulus',
    'B annulus',
    'C annulus',
    'D annulus'
  ];

  constructor(
    public service: CDFTService) { }

  ngOnInit() {
    this.service.cdftErrors$.subscribe((err)=> {
      if(!err) return

      this.errorList = groupErrors(err);

    })
  }

  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }
}
